export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7067.75be5a3e.jpg";